import React, { useState } from 'react';
import './blog-post.css';
import './blog-slides.css';

import paintings from './pictures/paintings.JPG';
import attendees from './pictures/waterColorattendees.jpg';
import weather from './pictures/weather.JPG';

const Watercolor = () => {
  return (
    <div>
      <div className='blog__container'>
        <div class="row">
            <div class="column">
                <header></header>

                <section>
                    <h2>Spring MM2: Watercolor with WiC at the Cut</h2>
                    <p class="site-post-meta">May 7, 2025</p>
                    <hr></hr>
                </section>
                <section>
                    <p>Hi WiC Members!

                    <br></br>
                    <br></br>

                    Thank you so much for everyone who joined us for our Watercolor with WiC event! We had an amazing time seeing everyone's amazing watercolor art with our fresh water from the cut (courtesy of Chloe)! We hope everyone enjoyed the amazing weather, snacks, and drinks! 
                    
                    <br></br>
                    <br></br>
                    
                    </p>
                    <img src={paintings} alt="Paintings created by attendees at event."/>
                    <img src={attendees} alt="Attendees posing at the event."/>
                    <img src={weather} alt="The weather at the event at the cut."/>
                    
                </section>
                
            </div>
        </div>      
      </div>
    </div>
  );
};

export default Watercolor;
